<template>
	<div class="contentbox">
		<div class="media-add-video-list">
			<div class="top-search">
				<el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
					<!--<el-form-item label="小程序" prop="appId" v-if="!isAgent">-->
					<!--<app-list @operateNovelByBookIdgetAppId="getAppId" :appId="formInline.appId" clear="noclear"></app-list>-->
					<!--</el-form-item>-->
					<el-form-item label="小说ID" prop="bookId">
						<el-input type="number" v-model="formInline.bookId" placeholder="请输入小说ID" clearable @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="小说名称" prop="bookName">
						<el-input v-model="formInline.bookName" placeholder="请输入小说名" clearable @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="上架状态" prop="rackStatus" style="margin-right: 30px;">
						<el-select v-model="formInline.rackStatus" placeholder="请选择上架状态" clearable @change="search" style="width: 150px;">
							<el-option v-for="item in rackStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="一级分类" prop="firstCategoryId" style="margin-right: 30px;">
						<el-select v-model="formInline.firstCategoryId" placeholder="请选择一级分类" clearable @change="firstClick" style="width: 150px;">
							<el-option v-for="item in firstCateOptions" :key="item.firstCategoryId" :label="item.firstCategoryName" :value="item.firstCategoryId"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="二级分类" prop="secondCategoryId" style="margin-right: 30px;">
						<el-select v-model="formInline.secondCategoryId" placeholder="请选择二级分类" clearable @change="search" style="width: 150px;">
							<el-option v-for="item in secondCateOptions" :key="item.secondCategoryId" :label="item.secondCategoryName" :value="item.secondCategoryId"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
					<div class="fr">
						<el-form-item>
							<el-button type="success" v-has="'novvel:add'" icon="el-icon-circle-plus-outline" @click="addData">添加</el-button>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle" v-loading="loadingTabel">
					<el-table-column prop='' label="序号" width="80">
						<template slot-scope="scope">
							<span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
						</template>
					</el-table-column>
					<el-table-column label="小说信息" width="200">
						<template slot-scope="scope">
							<div class="td-info">
								<p>小说名称：{{ scope.row.bookName }}</p>
								<p>别名：{{ scope.row.aliasName}}</p>
								<p>小说ID：{{ scope.row.bookId}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="书籍信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>总章节：{{ scope.row.chapterSize }}</p>
								<p>总字数：{{ scope.row.sumWords }}</p>
								<p>已更新章节：{{ scope.row.newChapter }}</p>
								<p>是否完结：{{ scope.row.writingStatus === 1 ? '完结' : '连载' }}</p>
								<!--<p>作者名：{{ scope.row.penName }}</p>-->
							</div>
						</template>
					</el-table-column>
					<el-table-column label="封面" width="150">
						<template slot-scope="scope">
							<img class="cover" :src="scope.row.coverName ? scope.row.coverName : scope.row.coverNameDefault" />
						</template>
					</el-table-column>
					<el-table-column label="章节解锁信息" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>免费章节：{{ scope.row.userFreeChapter }}</p>
								<p>
									解锁模式：
									<span v-if="scope.row.priceFlag == 1">纯广告解锁</span>
									<span v-if="scope.row.priceFlag == 2">纯付费解锁</span>
									<span v-if="scope.row.priceFlag == 4">广告+付费解锁</span>
									<!--<span v-if="scope.row.chargeType == 4">混合解锁</span>-->
									<!--<span v-if="scope.row.chargeType == 5">整本购买</span>-->
								</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="其他信息" width="200">
						<template slot-scope="scope">
							<div class="td-info">
								<p>封面角标：
									<span v-if="scope.row.cornerMarker == 0" class="primary-text">不开启</span>
									<span v-if="scope.row.cornerMarker == 1" class="succes-text">开启</span></p>
								<p>角标文案：{{ scope.row.cornerContent }}</p>
								<p>推荐语：{{ scope.row.recText }}</p>
								<p>频道: </p>
								<p>类别：</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="上架状态" width="130" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.rackStatus == 0" class="danger-text">下架</span>
							<span v-if="scope.row.rackStatus == 1" class="succes-text">上架</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" fixed="right">
						<template slot-scope="scope" class="ddd">
							<el-button type="primary" v-has="'novvel:update'" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row.bookId)">编辑</el-button>
							<el-button v-if="scope.row.rackStatus == 0" v-has="'novvel:addrackStatus'" type="success" size="mini" @click="handleStatus(scope.row.bookId)">上架</el-button>
							<el-button v-if="scope.row.rackStatus == 1" v-has="'novvel:addrackStatus'" type="danger" size="mini" @click="handleStatus(scope.row.bookId)">下架</el-button>
							<el-popover width="160" v-has="'novvel:delete'" :ref="scope.row.bookId" style="margin: 0 10px;">
								<p class="popover-con del">
									<i class="el-icon-question warnning-text"></i>确定删除吗？
								</p>
								<div style="text-align: right; margin: 0">
									<el-button size="mini" @click="$refs[scope.row.bookId].doClose()">取消</el-button>
									<el-button type="primary" size="mini" @click="handleDeleteBook(scope.row.bookId)">确定</el-button>
								</div>
								<!--<el-button slot="reference" type="danger" icon="el-icon-delete"  size="mini">删除</el-button>-->
								<el-button slot="reference" type="danger" icon="el-icon-delete" :disabled="scope.row.rackStatus == 1 ? true : false" size="mini">删除</el-button>
							</el-popover>
							<el-button type="success" size="mini" @click="handlePreview(scope.row.bookId)">预览</el-button>
							<!--<el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>-->
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :page-sizes="[20, 50, 100, 200, 500]" :page-size="tableData.pageSize" background :current-page="currentPage" layout="sizes, prev, pager, next, jumper, ->, total" :total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" center width="800px">
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
				<tbody>
				<tr>
					<td>小说ID</td>
					<td>
						{{ruleForm.bookId}}
					</td>
				</tr>
				<tr>
					<td width="200">小说信息</td>
					<td>
						<p>小说名称：{{ ruleForm.bookName }}</p>
						<p>
							作品状态：
							<span v-if="ruleForm.serialStatus == 1" class="primary-text">连载</span>
							<span v-if="ruleForm.serialStatus == 2" class="succes-text">完结</span>
						</p>
						<p>小说类型：{{ ruleForm.novelType }}</p>
						<p>总字数：{{ ruleForm.sumWords }}</p>
						<p>总章数：{{ ruleForm.chapterSize }}</p>
						<p>付费信息：付费</p>
					</td>
				</tr>
				<tr>
					<td>小说封面</td>
					<td>
						<img class="cover" :src="ruleForm.coverName" />
					</td>
				</tr>
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
		<!--修改弹框-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="700px">
			<el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="150px" class="input350" size="small" style="max-height: 550px;overflow: auto; padding-right: 20px;">
				<el-form-item label="小说ID：" prop="bookId">
					<el-input type="number" v-model="ruleForm.bookId" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="小说名称：" prop="bookName">
					<el-input v-model="ruleForm.bookName" placeholder="请输入小说原名" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="别名：" prop="aliasName">
					<el-input v-model="ruleForm.aliasName" placeholder="请输入小说别名"></el-input>
				</el-form-item>
				<el-form-item label="封面图：">
					<el-upload class="avatar-uploader" action="short/video/info/uploadImage" :show-file-list="false" :on-change="(file, fileList) => handleUpimg('picUrl', file, fileList)">
						<img v-if="ruleForm.coverName" :src="ruleForm.coverName" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<!--<p class="upimgId" v-if="ruleForm.videolistVo.picId">图片id：{{ ruleForm.picId }}</p>-->
				</el-form-item>
				<el-form-item label="总章节：" prop="chapterSize">
					<el-input type="number" v-model="ruleForm.chapterSize" placeholder="请输入总章节" :disabled="true"></el-input>
				</el-form-item>
				<!--<el-form-item label="总字数：" prop="sumEps">-->
					<!--<el-input type="number" v-model="sumEps" placeholder="请输入总字数" :disabled="true"></el-input>-->
				<!--</el-form-item>-->
				<el-form-item label="已更新章节：" prop="newChapter">
					<el-input type="text" v-model="ruleForm.newChapter" placeholder="请输入已更新集数" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="是否完结：" prop="writingStatus">
					<el-switch v-model="ruleForm.writingStatus" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" :disabled="true">
					</el-switch>
				</el-form-item>
				<el-form-item label="作者：" prop="penName">
					<el-input type="text" v-model="ruleForm.penName" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="免费章节数：" prop="userFreeChapter">
					<el-input type="number" v-model="ruleForm.userFreeChapter" :disabled="platform == 'wb-dp' ? true : false" placeholder="请输入免费章节数"></el-input>
				</el-form-item>
				<el-form-item label="小说解锁模式：" prop="priceFlag">
					<el-select v-model="ruleForm.priceFlag" filterable clearable placeholder="请选择小说解锁模式">
						<el-option v-for="item in priceFlagOptions" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
						</el-option>
					</el-select>
				</el-form-item>
				<!--<el-form-item v-if="ruleForm.priceFlag == 2" label="章节价格：" prop="chapterPrice">-->
					<!--<el-input type="number" v-model="ruleForm.chapterPrice" placeholder="请输入章节价格"></el-input>-->
				<!--</el-form-item>-->
				<!--<el-form-item v-if="ruleForm.priceFlag == 5" label="整本价格：" prop="finishPrice">-->
					<!--<el-input type="number" v-model="ruleForm.finishPrice" placeholder="请输入免费章节数"></el-input>-->
				<!--</el-form-item>-->
				<el-form-item label="封面角标：" prop="cornerMarker">
					<el-switch v-model="ruleForm.cornerMarker" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0">
					</el-switch>
				</el-form-item>
				<el-form-item label="角标文案：" prop="cornerContent">
					<el-input v-model="ruleForm.cornerContent" placeholder="请输入角标文案" style="width: 180px; float: left;"></el-input>
					<div class="block" style="display: inline-block; float: left; margin-left: 15px; height: 32px;">
						<el-color-picker v-model="ruleForm.cornerColor"></el-color-picker>
					</div>
				</el-form-item>
				<el-form-item label="推荐语：" prop="recText">
					<el-input type="text" v-model="ruleForm.recText" placeholder="请输入8个汉字以内的推荐语" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="短篇简介：" prop="intro">
					<el-input type="textarea" v-model="ruleForm.intro" placeholder="请输入200字以内短剧简介" :rows="5" maxlength="200" :disabled="true" show-word-limit></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 预览剧集 -->
		<el-dialog title="预览"  :visible.sync="dialogViewVisible" width="600px">
			<div class="preview-img">
				<div style="text-align: left; padding: 0 30px 15px; border-bottom: 1px dotted #ddd; margin: -10px -20px 0;">
					<span>章节名：</span>
					<el-select v-model="currentPageChapter" filterable clearable placeholder="请选择章节" @change="changeChapter">
						<el-option v-for="item in catalogList" :key="item.chapterId" :label="item.chapterTitle" :value="item.chapterNumber" :disabled="item.disabled">
						</el-option>
					</el-select>
					<span style="margin-left: 50px;">总字数：{{chapterCon.ChapterSumWords}}</span>
				</div>
				<div class="chapter-con" style="padding: 20px 10px; font-size: 15px; line-height: 30px; text-align: left;">
					<div style="max-height: 500px; overflow-y: auto; text-align: justify; padding: 0 10px;" v-html="chapterCon.content">
					</div>
				</div>
				<div class="dialog-footer" style="margin-top: 20px;">
					<el-button plain size="mini"  :disabled="currentPageChapter == 1" @click="changePage(currentPageChapter - 1)">上一页</el-button>
					<span class="page-size"> <span>&nbsp;{{currentPageChapter}}</span>&nbsp;/&nbsp;{{catalogList.length}}&nbsp;</span>
					<el-button plain size="mini" :disabled="currentPageChapter == catalogList.length" @click="changePage(currentPageChapter + 1)">下一页</el-button>
				</div>
			</div>
		</el-dialog>
		<book-table-more :visible.sync="isShowDialogBook" :appId="formInline.appId" @bookSure="bookSure" @cancelDialogBook="cancelDialogBook"></book-table-more>
	</div>
</template>
<script>
    import BookTableMore from '@/components/dydp/BookTableMore';
    // import AppTableMore from '@/components/AppTableMore'
    import { listBook, details, addBook, del, catalog, content, listBookAdd, firstcate, secondcate} from "@/api/dydp/media/manage";
    // import videojs from "video.js";
    // import "video.js/dist/video-js.css";
    export default {
        components: {
            // AppList,
            BookTableMore
        },
        data() {
            var validateNum = (rule, value, callback) => {
                if (!(/(^[1-9]\d*$)/.test(value))) {
                    return callback(new Error('数字应为正整数'));
                } else {
                    callback();
                }
            };
            return {
                loadingTabel: false,
                platform: localStorage.getItem('platform'),
                formInline: {
                    // appId: localStorage.getItem('appId'),
                    bookId: '',
                    bookName: '',
                    rackStatus: '',
                    firstCategoryId: '',
                    secondCategoryId: ''
                },
                rackStatusOptions: [
                    {
                        value: 0,
                        label: '下架'
                    },
                    {
                        value: 1,
                        label: '上架'
                    }
                ],
				firstCateOptions: [],
				secondCateOptions: [],
                priceFlagOptions: [
                    {
                        value: 1,
                        label: '纯广告解锁'
                    },
                    {
                        value: 2,
                        label: '纯付费解锁'
                    },
                    {
                        value: 4,
                        label: '广告+付费解锁'
                    },
                    // {
                    //     value: 4,
                    //     label: '混合解锁'
                    // },
                    // {
                    //     value: 5,
                    //     label: '整本购买'
                    // }
                ],
                tableData: {
                    pageSize: 20,
                    pageNo: 1,
                    totalPage: 1,
                    totalNum: 1,
                    result: []
                },
                currentPage: 1,
                dialogInfoVisible: false, // 详情弹框
                dialogTitle: '添加',
                dialogFormVisible: false, // 编辑弹框
                ruleForm: {
                },
                rules: {
                    userFreeChapter: [
                        { required: true, message: '请输入免费章节数', trigger: 'blur' },
                        { validator: validateNum, trigger: 'blur' }
                    ],
                    priceFlag: [
                        { required: true, message: '请选择小说解锁模式', trigger: 'change' },
					]
                    // chapterPrice: [
                    //     { required: true, message: '请输入章节价格', trigger: 'blur' },
                    //     { validator: validateNum, trigger: 'blur' }
                    // ],
                    // finishPrice: [
                    //     { required: true, message: '请输入整本价格', trigger: 'blur' },
                    //     { validator: validateNum, trigger: 'blur' }
                    // ]
                },
                isAgent: false,
                dialogViewVisible:false,//预览剧集
				editBookId: '',
				catalogList: [],
                currentPageChapter: 1,
				chapterCon: {},
                isShowDialogBook: false
            }
        },
        computed: {},
        watch: {
        },
        mounted: function () {
            if (JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
                this.isAgent = true
                this.formInline.appId = JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId
            }
            this.getTableData()
            this.getFirstCate()
        },
        beforeDestroy() {
        },
        methods: {
            search () {
                this.currentPage = 1
                this.getTableData()
            },
            resetQuery() {
                this.$refs['formInline'].resetFields()
                this.getTableData()
            },
            handleCurrentChange(value) {
                this.currentPage = value
                this.getTableData()
            },
            handleSizeChange(val) {
                this.tableData.pageSize = val
                this.currentPage = 1
                this.getTableData()
            },
            handleEdit(id) {
                this.getDetails(id, 'edit')
                this.dialogFormVisible = true
			},
            getDetails(id, text) {
                details({
                    bookId: id
                }).then(response => {
                    if (response.data.head.flag === 0) {
						this.ruleForm = response.data.content
						this.ruleForm.change = 'upd'
						if (text == 'status') {
                            this.ruleForm.rackStatus = this.ruleForm.rackStatus == 1 ? 0 : 1
                            this.saveTableData()
						}
					} else {
						this.$message.error(response.data.head.desc)
					}
				});
            },
            handleStatus(bookId) {
                this.getDetails(bookId, 'status')
            },
            // 弹框确定
            editDialogSureBtn(formName) {
                console.log(this.ruleForm)
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        console.log(this.ruleForm.change)
                        this.saveTableData()
                    } else {
                        console.log('error submit!!');
						return false;
					}
				});
            },
            // 保存编辑信息
            saveTableData() {
                addBook(this.ruleForm).then(response => {
                    if (response.data.head.flag === 0) {
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.getTableData()
						this.dialogFormVisible = false
					} else {
						this.$message.error(response.data.head.desc);
					}
				})
            },
            // 删除
            handleDeleteBook(id) {
                console.log(id)
                del({
                    bookId: id
                }).then(response => {
                    if (response.data.head.flag === 0) {
						if (this.tableData.result.length === 1 && this.currentPage > 1) {
							this.currentPage = this.currentPage - 1
						}
						this.$refs[id].doClose()
						this.getTableData()
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
					} else {
						this.$message.error(response.data.head.desc);
					}
				})
            },
            getTableData() {
                let json2 = {
                    pageNo: this.currentPage,
                    pageSize: this.tableData.pageSize
                };
                let json1 = this.formInline;
                let paramJson = { ...json1, ...json2 };
                listBook(paramJson).then(response => {
                    if (response.data.head.flag === 0) {
						this.tableData = response.data.content
					} else {
						this.$message.error(response.data.head.desc)
					}
				});
            },
            firstClick(val) {
                this.getSecondCate(val)
				this.search()
			},
            getFirstCate() {
                firstcate({}).then(response => {
                    if (response.data.head.flag === 0) {
						this.firstCateOptions = response.data.content
					} else {
						this.$message.error(response.data.head.desc)
					}
				});
            },
            getSecondCate(id) {
                secondcate({
                    firstCategoryId: id
				}).then(response => {
                    if (response.data.head.flag === 0) {
						this.secondCateOptions = response.data.content
					} else {
						this.$message.error(response.data.head.desc)
					}
				});
            },
			// 预览
            handlePreview(bookId) {
                this.getCatalog(bookId)
				this.dialogViewVisible = true
				this.getChapterCon(bookId, 1)
				this.editBookId = bookId
				this.currentPageChapter = 1
			},
			// 获取目录
			getCatalog (bookId) {
                catalog({
					bookId: bookId
				}).then(response => {
                    if (response.data.head.flag === 0) {
						this.catalogList = response.data.content.map((item) => {
							return {
								chapterId: item.id,
								chapterTitle: item.chaptertitle,
                                chapterNumber: item.chapterNumber
							}
						})
						console.log(this.catalogList)
					} else {
						this.$message.error(response.data.head.desc)
					}
				});
			},
            // 获取内容
            getChapterCon (bookId, chapterNumber) {
                content({
                    bookId: bookId,
                    chapterNumber: chapterNumber
                }).then(response => {
                    if (response.data.head.flag === 0) {
                    this.chapterCon = response.data.content
                    console.log(this.chapterCon.content)
                    this.chapterCon.content = response.data.content.content.replace(/\r\n/g, '<br/>')
                    console.log(this.chapterCon.content)
					} else {
						this.$message.error(response.data.head.desc)
					}
				});
            },
            // 切换章节
            changeChapter (val) {
                this.currentPageChapter = val
				this.getChapterCon(this.editBookId, val)
            },
			changePage(page) {
                this.currentPageChapter = page
                this.getChapterCon(this.editBookId, page)
			},
            // 图片上传
            handleUpimg(text, file, fileList) {
                console.log(file, fileList);
                console.log(text);
                if (file.status === 'success') {
                    if (file.response.head.flag === 0) {
                        this.ruleForm.coverName = file.response.content.imgPath
                        this.$notify({
                            title: '上传成功',
                            message: '上传成功',
                            type: 'success'
                        })
                        this.$refs['ruleForm'].clearValidate(text)
                    } else {
                        this.$message.error(file.response.data.head.desc)
                    }
                } else if (file.status === 'fail') {
                    // console.log(file.status)
                    this.$notify.error({
                        title: '上传失败',
                        message: '上传失败，请重新再传'
                    })
                    this.ruleForm.coverName = ''
                }
            },
            addData() {
                this.isShowDialogBook = true
			},
            // 关闭选剧弹窗
            cancelDialogBook(data) {
                console.log('cancel')
                this.isShowDialogBook = data
            },
            // 确定剧
            bookSure(data) {
                console.log("确定剧", data)
                this.dataIds = data.bookListStr.split(',').map((item) => {
                    return parseInt(item)
				})
                this.selectBook = data
                listBookAdd(this.dataIds).then(response => {
                    if (response.data.head.flag === 0) {
                    this.getTableData()
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
            },
        }
    }
</script>
<style lang="scss" scoped>
	.preview-img {
		width: 100%;
		text-align: center;

		.preview-title{
			font-size: 16px;
			margin: -60px 0 30px 0;
		}

		.video-demo {
			width: 100%;
			height: 100%;
		}

		video {
			max-width: 100%;
			max-height: 100%;
			object-fit: contain; /* 保持视频比例 */
		}

	}

</style>
